<template>
  <vetster-symptom-table
    :title="title"
    :items="items"
  />
</template>

<script>
import VetsterSymptomTable from '@/components/VetsterSymptomTable';

export default {
  name: 'VetsterTable',

  components: { VetsterSymptomTable },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
